import { parsePaging } from '../utils';
import { toItem } from '../mappers/item';
export function parseItems(res, settings, thumbnailSizes) {
  res.paging = parsePaging(res.data);
  res.data = res.data.items ? res.data.items.map(function (itemData) {
    return toItem(itemData, settings, thumbnailSizes);
  }) : [];
  return res;
}